import { Modal } from '@carbon/react';

import styles from 'theme/features/auth/login.module.scss';

const NoAccessModal = ({ open, onLogout, onRequestAccess }) => (
  <Modal
    open={open}
    size="xs"
    modalHeading="No Access"
    primaryButtonText="Request Access Link"
    secondaryButtonText="Logout"
    preventCloseOnClickOutside
    onRequestSubmit={onRequestAccess}
    onSecondarySubmit={onLogout}
    className={styles['no-access-modal']}
  >
    <p>
      You don't have access to the LCS Planning tool at present. <br />
      You can click the link below to request access or try again later.
    </p>
  </Modal>
);

export default NoAccessModal;
